import { render, staticRenderFns } from "./ca-catalogue.vue?vue&type=template&id=4bfa3c92&scoped=true"
import script from "./ca-catalogue.vue?vue&type=script&lang=js"
export * from "./ca-catalogue.vue?vue&type=script&lang=js"
import style0 from "./ca-catalogue.vue?vue&type=style&index=0&id=4bfa3c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa3c92",
  null
  
)

export default component.exports